/**
 * Product Info Web Component
 * Container for product information that may need updates
 */
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Listen for variant changes if pubsub is available
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }
      }

      disconnectedCallback() {
        if (this.onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber();
        }
      }

      handleVariantChange({ data }) {
        // Handle any additional updates needed when variant changes
        // Currently variant-selects.js handles most updates directly
      }

      get productForm() {
        return this.querySelector('product-form');
      }

      get sectionId() {
        return this.dataset.section;
      }
    }
  );
}
